<div class="signin-page mat-typography custom-input flex-column justify-between align-stretch">
  <!-- Signin page Header-->
  <div class="landing-page-header full-size flex-1">
    <app-header imageUrl="./assets/imgs/backgrounds/signin.jpg">
      <app-back-button></app-back-button>
      <app-logo class="site-search-page-logo hide-gt-xs"></app-logo>
    </app-header>
  </div>

  <!-- Login form-->
  <div class="login-container centered">
    <app-signin-form (signIn)="signIn($event)"
                     (signUp)="signUp()"
                     (goBack)="goBack()"
                     [disabled]="isLoading"
                     [showGoToMenuButton]="showGoToMenuButton"
                     (goToMenu)="goToMenu()"></app-signin-form>
  </div>
</div>
